// flag the prompt or user, update the flaggedPrompts or flaggedUsers subcollection of the reporter
// note that this action creator does Not have a corresponding reducer
import {
  doc,
  collection,
  setDoc,
  getDocs,
  serverTimestamp
} from 'firebase/firestore';
import { firestore } from '../firebase';
import {
  asyncActionStart,
  asyncActionFinish,
  asyncActionError
} from './asyncActions';
import { openSnackbar } from './snackbarActions';
import { GET_FLAGGED_USERS } from './types';

// get flagged users, only used in Flagged Users Admin page
export const getFlaggedUsers = () => async dispatch => {
  dispatch(asyncActionStart());
  try {
    const usersFlaggedRef = collection(firestore, 'usersFlagged');
    const usersFlaggedSnapshots = await getDocs(usersFlaggedRef);
    const usersFlagged = usersFlaggedSnapshots.docs.map(docSnap => {
      const { id } = docSnap;
      const data = docSnap.data();
      return { ...data, id };
    });
    dispatch({ type: GET_FLAGGED_USERS, payload: { usersFlagged } });
    dispatch(asyncActionFinish());
  } catch (error) {
    console.error(error);
    dispatch(asyncActionError());
  }
};

export const flagUser = flagObject => async (dispatch, getState) => {
  dispatch(asyncActionStart());
  try {
    const { userID, reason, comment } = flagObject;
    const reporterID = getState().auth.currentUser.uid;

    // add the flag to the reporter's flaggedUsers subcollection
    const reporterFlaggedUserRef = doc(
      firestore,
      'usersPrivate',
      reporterID,
      'flaggedUsers',
      userID
    );

    await setDoc(reporterFlaggedUserRef, {
      reason,
      comment,
      userID,
      reporterID,
      createdAt: serverTimestamp()
    });
    dispatch(
      openSnackbar('SuccessSnackbar', {
        message: 'successfully reported the user!'
      })
    );
    dispatch(asyncActionFinish());
  } catch (error) {
    console.error(error);
    dispatch(
      openSnackbar('ErrorSnackbar', {
        message: 'Could not submit your report. Please try again.'
      })
    );
    dispatch(asyncActionError());
  }
};

export const flagPrompt = flagObject => async (dispatch, getState) => {
  dispatch(asyncActionStart());
  try {
    const {
      promptID,
      reason,
      comment,
      promptCreatorID,
      promptCreator,
      promptTitle
    } = flagObject;
    const userID = getState().auth.currentUser.uid;

    // add the flag to the user
    const userPromptRef = doc(
      firestore,
      'usersPrivate',
      userID,
      'flaggedPrompts',
      promptID
    );
    await setDoc(userPromptRef, {
      reason,
      comment,
      promptCreatorID,
      promptCreator,
      promptTitle
    });
    dispatch(
      openSnackbar('SuccessSnackbar', {
        message: 'successfully reported the prompt!'
      })
    );
    dispatch(asyncActionFinish());
  } catch (error) {
    console.error(error);
    dispatch(
      openSnackbar('ErrorSnackbar', {
        message: 'Could not submit your report. Please try again.'
      })
    );
    dispatch(asyncActionError());
  }
  return null;
};
